import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle, Loader2, CreditCard } from "lucide-react";

// Global banner shown while a subscription payment is failing. During the 7-day grace period
// it is amber (access maintained); once restricted it turns red. Button opens the Stripe portal.
export default function BillingBanner() {
  const { organization, orgId } = useAuth();
  const [loading, setLoading] = useState(false);
  const status = organization?.subscription_status;
  if (!organization || status !== "past_due") return null;
  const restricted = !!organization.restricted;

  const openPortal = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/api/billing/portal", {}, { params: { organization_id: orgId } });
      window.location.href = data.url;
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="billing-banner"
      className={`flex flex-wrap items-center justify-between gap-3 border-b px-4 py-3 text-sm sm:px-6 ${
        restricted ? "border-rose-200 bg-rose-50 text-rose-800" : "border-amber-200 bg-amber-50 text-amber-800"
      }`}
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span data-testid="billing-banner-message">
          {restricted
            ? "Accès restreint : votre abonnement n'a pas pu être renouvelé. Mettez à jour votre moyen de paiement pour rétablir l'accès."
            : "Un problème est survenu lors du renouvellement de votre abonnement. Mettez à jour votre moyen de paiement."}
        </span>
      </div>
      <button
        onClick={openPortal}
        disabled={loading}
        data-testid="billing-banner-update-payment"
        className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-50 ${
          restricted ? "bg-rose-600 hover:bg-rose-700" : "bg-amber-600 hover:bg-amber-700"
        }`}
      >
        {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CreditCard className="h-3.5 w-3.5" />}
        Mettre à jour mon paiement
      </button>
    </div>
  );
}
